import { Box, Typography, Avatar, IconButton, Menu, MenuItem, Divider, Badge, Grid2, Drawer, List } from '@mui/material';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import React, { useEffect, useState } from 'react';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import './AdminHeader.scss';
import MenuIcon from '@mui/icons-material/Menu';

import Logo from './../../../../assets/images/logo.svg';
import avatarUrl from './../../../../assets/images/dummy/profile.svg';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setToast } from '../../../../store/slices/toastSlice';
import { setUser } from '../../../../store/slices/userSlice';
import { getUser } from '../../../../utils/types';
import SystemNotificationDialog from '../../../../shared/SystemNotificationPopup/SystemNotificationDialog';
import CloseIcon from '@mui/icons-material/Close';
import SideNavigation from '../AdminSidenav/SideNavigation/SideNavigation';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";


const AdminHeader: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const reduxUser = useSelector((state: any) => state.user);
    const user: any = getUser()
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        handleMenuClose();
        sessionStorage.clear();
        dispatch(setUser({ expires: null, refreshToken: null, roles: null, token: null, user: null }))
        dispatch(
            setToast({
                message: "Logout Successfully",
                severity: "success",
                open: true,
            })
        );
        navigate('/');
    }

    const handleMenuNavigate = (url: string) => navigate(url)


    return (
        <>
        <Box className="admin_header__wrapper">
            <Grid2 container alignItems={"center"} sx={{ width: "100%" }}>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <Box className="site-logo" >
                        <img src={Logo} alt="NIC Logo" onClick={()=>navigate('/')} style={{ cursor: "pointer" }}/>
                    </Box>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <Box sx={{
                        display: "flex",
                        justifyContent: {xs: "space-between", md: "end"},
                        alignItems: "center"
                    }}>
                        <IconButton
                            edge="end"
                            color="inherit"
                            aria-label="menu"
                            onClick={() => setDrawerOpen(true)} 
                            sx={{ display: { xs: 'block', md: 'none' } ,color:'black !important'}} 
                        >
                            <MenuIcon />
                        </IconButton>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "center"
                        }}>
                            <SystemNotificationDialog />
                            <Box className="profile-dropdown-container">{
                               ( user?.roles?.role_code=='candidate'||user?.roles?.role_code=='bidder')?
                               <Avatar src={user?.user?.infracon_kp_photo||AccountCircleIcon} className="profile-avatar" />:
                               <Avatar sx={{ width: 56, height: 56 }} className="profile-avatar">
                                    <PersonIcon sx={{ fontSize: 38 }} />
                                </Avatar>}
                                <Box className="profile-info">
                                    <Typography variant="body1" className="profile-name">
                                        {user?.user?.fullname || "NA"}
                                    </Typography>
                                    <Typography variant="body2" className="profile-role">
                                        {user?.roles?.name || "NA"}
                                    </Typography>
                                </Box>
                                <IconButton className="dropdown-icon" onClick={handleMenuOpen}>
                                    <KeyboardArrowDownRoundedIcon />
                                </IconButton>
                                <Menu
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={handleMenuClose}
                                    className="profile-menu"
                                >
                                    <MenuItem onClick={() => handleMenuNavigate('/admin/profile')} className="menu-item">
                                        <PersonIcon fontSize="small" />
                                        <Typography variant="body2" className="menu-text">
                                            Profile Settings
                                        </Typography>
                                    </MenuItem>
                                    { (user?.roles?.role_code!="candidate" && user?.roles?.role_code!="bidder")&&
                                    <MenuItem onClick={() => handleMenuNavigate('/admin/change-password')} className="menu-item">
                                        <LockIcon fontSize="small" />
                                        <Typography variant="body2" className="menu-text">
                                            Change Password
                                        </Typography>
                                    </MenuItem>
                                    }
                                    <MenuItem onClick={handleLogout} className="menu-item">
                                        <ExitToAppIcon fontSize="small" />
                                        <Typography variant="body2" className="menu-text">
                                            Logout
                                        </Typography>
                                    </MenuItem>
                                </Menu>
                            </Box>
                        </Box>
                    </Box>
                </Grid2>
            </Grid2>
        </Box >
        <Drawer className='sidebar-drawer-menu' anchor="left" open={drawerOpen}
                ModalProps={{
                    disableScrollLock: true,
                }}>
                <Box  className="drawer-toggle-icon">
                    <IconButton onClick={() => setDrawerOpen(false)} edge="start">
                        <CloseIcon />
                    </IconButton>
                </Box>
                <SideNavigation />
            </Drawer>
        </>
    )
}


export default AdminHeader